import { __extends } from "tslib";
import React from 'react';
import ReactTable from 'react-table';
import { ITranslations } from "../../models/translations";
import "../../../style/components/table.scss";
var ReportTable = (function (_super) {
    __extends(ReportTable, _super);
    function ReportTable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ReportTable.prototype.render = function () {
        var _a = this.props, data = _a.data, t = _a.t;
        if (!data) {
            return null;
        }
        var columnHeaders = data && data.columnHeaders;
        var rows = data && data.rows;
        var tableData = [];
        if (rows && rows.length > 0) {
            for (var _i = 0, rows_1 = rows; _i < rows_1.length; _i++) {
                var row = rows_1[_i];
                var dataRow = {};
                for (var i = 0; i < row.length; i += 1) {
                    dataRow[columnHeaders[i].name] = row[i];
                }
                tableData.push(dataRow);
            }
        }
        var columns = columnHeaders.map(function (header) { return ({
            Header: header.title,
            accessor: header.name,
        }); });
        return (React.createElement("div", { className: 'rb-table' },
            React.createElement(ReactTable, { className: '-striped', data: tableData, columns: columns, previousText: t.tablePreviousText, nextText: t.tableNextText, loadingText: t.tableLoadingText, noDataText: t.tableNoDataText, pageText: t.tablePageText, ofText: t.tableOfText, rowsText: t.tableRowsText, pageJumpText: t.tablePageJumpText, rowsSelectorText: t.tableRowsSelectorText })));
    };
    return ReportTable;
}(React.Component));
export { ReportTable };
